module.exports = __webpack_public_path__ + "media/src/images/certificates/milestone_uncompleted-13e233fc29b343364bdad847150d393b.svg";